// src/components/common/PlanInfoView.js
// 78차 64차: 신규 — 총관리자 화면(SuperAdminStoresScreen.js)에만 있던 "플랜 안내"
// (플랜별 요금·기능 비교표)를 매장관리자도 볼 수 있게 요청받아, 두 화면이 같은 내용을
// 따로 들고 있다가 어긋나지 않도록 공용 컴포넌트로 분리(총관리자 화면은 이 컴포넌트로
// 교체, 매장관리자 화면(StoreAdminScreen.js)에서도 그대로 재사용).
// PLAN_TIERS/PLAN_LABELS/PLAN_PRICES/PLAN_COLORS는 src/constants/index.js를 그대로
// 참조해 실제 게이트 로직과 항상 일치 — 기능 목록(PLAN_FEATURES) 자체는 이 화면 전용
// 정적 안내 텍스트라 planAtLeast() 게이트와는 무관.
// 80차 후속: "노출"(plan)과 "운영도구"(매장관리자 기능 애드온)를 분리 — 대형 프랜차이즈는
// 이미 자체 예약·정산 시스템이 있어 운영도구를 안 쓰는 경우가 많다는 게 확인돼, 억지로
// 한 사다리에 묶지 않고 애드온을 별도 카드로 분리.
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { PLAN_TIERS, PLAN_LABELS, PLAN_PRICES, PLAN_COLORS, OPS_ADDON_FEE } from '../../constants';
import { COLORS } from '../../constants/theme';
import { PriceIcon, CheckmarkIcon, IconLabel } from './Icons';

const PLAN_FEATURES = {
  standard: ['고객 앱 노출', '예약 관리 (확인/취소/수동 입력)', '운영시간 설정'],
  premium: ['STANDARD의 모든 기능', 'PICK 테마 노출(홈 화면·PICK 탭 상단 추천)', 'UNLOCK 기여도(즐겨찾기·리뷰·평점 통계)', '플랫폼 내 순위 비교'],
};

export default function PlanInfoView() {
  return (
    <View>
      <IconLabel Icon={PriceIcon} size={13} color={COLORS.gold} textStyle={s.sectionTitle}>플랜별 요금 및 기능</IconLabel>
      <Text style={s.muted}>
        가입한 플랜은 고객 앱에 노출되는 수준을 결정해요(플랫폼 수수료와는 별개).
      </Text>
      {PLAN_TIERS.map(tier => (
        <View key={tier} style={[s.card, { borderColor: PLAN_COLORS[tier]+'55' }]}>
          <View style={s.headerRow}>
            <Text style={[s.tierLabel, { color: PLAN_COLORS[tier] }]}>{PLAN_LABELS[tier]}</Text>
            <Text style={s.price}>월 {PLAN_PRICES[tier].toLocaleString()}원</Text>
          </View>
          {PLAN_FEATURES[tier].map((f, i) => (
            <View key={i} style={s.featureRow}>
              <CheckmarkIcon size={13} color={PLAN_COLORS[tier]} />
              <Text style={s.featureText}>{f}</Text>
            </View>
          ))}
        </View>
      ))}
      <View style={[s.card, { borderColor: COLORS.border, borderStyle: 'dashed' }]}>
        <View style={s.headerRow}>
          <Text style={[s.tierLabel, { color: COLORS.textMuted }]}>매장관리자 기능 (애드온)</Text>
          <Text style={s.price}>월 {OPS_ADDON_FEE.toLocaleString()}원 추가</Text>
        </View>
        <Text style={s.muted}>
          STANDARD/PREMIUM 어느 쪽이든, 예약 현황·통계·월별 정산 요약이 필요한 매장만 별도로 추가하는 옵션이에요. 자체 예약 시스템이 있어 노출만 필요하면 안 켜셔도 돼요.
        </Text>
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  sectionTitle: { color: COLORS.gold, fontSize: 15, fontWeight: '800' },
  muted: { color: COLORS.textMuted, fontSize: 12, lineHeight: 18, marginTop: 8, marginBottom: 16 },
  card: { backgroundColor: COLORS.surface, borderRadius: 12, borderWidth: 1, padding: 14, marginBottom: 12 },
  headerRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 },
  tierLabel: { fontSize: 16, fontWeight: '800', letterSpacing: 1 },
  price: { color: COLORS.text, fontSize: 15, fontWeight: '700' },
  featureRow: { flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 4 },
  featureText: { color: COLORS.textMuted, fontSize: 13, flexShrink: 1 },
});
